import React from 'react';
import { RouteObject } from 'react-router-dom';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';
import MapGridLayout from 'ff/debrief/layouts/MapGridLayout';
import MapControls from 'ff/debrief/components/map/MapControls';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import InfoSidebar from 'ff/debrief/components/debriefSidebar/InfoSidebar';
import DebriefSidebar from 'ff/debrief/components/debriefSidebar/DebriefSidebar';
import Timeline from 'ff/debrief/components/timeline';

interface Props {}

export const pathString = '/debrief/track/:tracklogId';

const SharePageRoute: React.FC<Props> = props => {
    return (
        <MapGridLayout>
            <MapControls />
            {isFeatureEnabled('debrief_features') ? (
                <DebriefSidebar />
            ) : (
                <InfoSidebar />
            )}
            {isFeatureEnabled('debrief_features') && <Timeline />}
            <ErrorBar />
        </MapGridLayout>
    );
};

const route: RouteObject = {
    path: pathString,
    element: <SharePageRoute />,
};

export default route;
